// The working value of a setting (R-C13) for the signed-in person, live in every screen.

import { resolveSetting, type Id, type SettingValue } from '@confdeck/core-shared';
import { useMeta, useSync } from '../sync/react.tsx';

/** The working value of a setting for the signed-in person, live: a change on the settings screen reaches every open table. */
export function useSetting(key: string, typeId: Id | null = null): SettingValue | undefined {
  const client = useSync();
  const meta = useMeta();
  const d = client.header?.settings?.find((x) => x.key === key);
  return d ? resolveSetting(meta, d, meta.user(client.header?.userId), typeId).value : undefined;
}
